import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import FreeTrialGTM from '../../utils/FreeTrialGTM';
import { AlertDialog } from '@homeexchange/design';
const FinalizeFreeTrialBlocker = ({ showTrialAlertBlocker, conversationId, closeTrialAlertBlocker }) => {
    const handleConfirmAction = () => {
        const paymentUrl = i18n.t('url:collection.subscription.payment');
        const conversationsUrl = i18n.t('user:user.infocard.unreplied_messages_url');

        FreeTrialGTM.trackFinalizationActivateMembership();

        document.location.assign(`${paymentUrl}?as=guest&redirectTo=${conversationsUrl}/${conversationId}`);
    };

    return (
        <AlertDialog
            confirmActionText={i18n.t(
                'collection:exchange-modal.activation-required-for-finalization.confirm-button'
            )}
            isOpen={showTrialAlertBlocker}
            dismissActionText={i18n.t(
                'collection:exchange-modal.activation-required-for-finalization.cancel-button'
            )}
            onConfirmAction={handleConfirmAction}
            onDismissAction={closeTrialAlertBlocker}
            title={i18n.t('collection:exchange-modal.activation-required-for-finalization.title')}
        >
            {i18n.t('collection:exchange-modal.activation-required-for-finalization.content')}
        </AlertDialog>
    );
};

FinalizeFreeTrialBlocker.propTypes = {
    showTrialAlertBlocker: PropTypes.bool.isRequired,
    conversationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeTrialAlertBlocker: PropTypes.func.isRequired
};

export default FinalizeFreeTrialBlocker;
